/******************************************************************
 * Archivo : client/src/queries/fetchViewerSurveyResult.js
 * Proyecto: CB30
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query ViewerSurveyResultQuery($id: ID!) {

    viewerSurveyResult(id: $id) {

      results {

        pregunta

        respuesta

      }

    }

  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchViewerSurveyResult.js